<template>
    <div>
        <div class="bg-primary-500">
            <Container>
                <div class="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-12 py-[40px] md:py-[81px]">
                    <div class="max-w-3xl flex-1 min-w-0">
                        <h2 class="text-[40px] font-[700] text-white font-outfit">About SubjectToClimate™</h2>
                        <p class="text-[24px] font-[400] text-white font-outfit">We envision a world where everyone feels empowered
                            to
                            take action in solving climate change. To create this future, climate action begins in the
                            classroom.</p>
                    </div>
                    <a target="_blank" class="md:ml-4"
                       href="https://app.candid.org/profile/10986729/climate-change-for-all-educators-inc-86-1536473">
                        <img
                    :src="imageSrc"
                    alt=""
                    class="h-[100px] w-auto max-w-none"
                />
                    </a>
                </div>

            </Container>

        </div>
        <div class="">
            <!--tab section-->
            <div>
                <div class="">
                    <div class="bg-[#D4DBE8]">
                        <Container>
                        <div class="flex w-full mb-[24px] pt-4 overflow-x-auto gap-4 md:gap-0">
                            <a v-for="(tabItem, index) in tabs"
                               :key="index"
                               @click="tab = index"
                              class="flex-shrink-0 flex-1 text-center text-[24px] font-outfit cursor-pointer pb-[16px] border-b-4 whitespace-nowrap px-3 md:px-0"
                               :class="tab === index ? 'text-[#556FA4] font-[700]' : 'text-[#6B8FB9] border-transparent font-[500]'">
                                {{ tabItem.title }}
                            </a>
                        </div>
                    </Container>
                    </div>

                    <div class="relative">
                        <div v-for="(tabItem, tabIndex) in tabs"
                             :key="tabIndex"
                             v-show="tab === tabIndex"
                             class="">
                            <div v-if="tab === 0" class="">
                                <Container class="px-6 md:px-0">
                                    <ReadOurStoryComponent
                                        :our-story-button-link="tabItem.ourStoryButtonLink"
                                        :our-story-image-src="tabItem.ourStoryImageSrc"
                                        :our-story-open-new-tab="tabItem.ourStoryOpenNewTab"
                                        :our-story-sub-title="tabItem.ourStorySubTitle"
                                        :our-story-title="tabItem.ourStoryTitle"
                                    />
                                    <AboutOurWorkComponent :about-our-work-image-src="tabItem.aboutOurWorkImageSrc" :about-our-work-message="tabItem.aboutOurWorkMessage" />
                                    <AboutAwardsComponent v-bind="tabItem.awards" />
                                </Container>

                                <div style="background: #E4F4FC;" class="py-[40px] px-6 md:px-0">
                                    <Container>
                                        <p class=" text-black font-outfit text-[28px] font-[700]">
                                            Core Platform
                                        </p>
                                        <p class="text-black mt-[20px] font-outfit text-[18px] font-[400]" >
                                            Our core platform (www.subjecttoclimate.org) is our free, easy-to-use hub
                                            that connects educators of all grade levels and subject areas to the
                                            resources they need to teach about climate change
                                            <br><br>
                                            How: We aim to increase the number of hours teachers spend teaching about
                                            climate change. We accomplish this by including educators in our development
                                            process - from the curation of the resources to the development of the
                                            exemplar lesson plans - so that the resources are truly relevant and
                                            supplemental to their classroom.
                                        </p>
                                        <CorePlatformGridComponent v-bind="tabItem.corePlatform" class="mt-[64px]" @item-selected="selectedGridItem = $event" />
                                        <LessonCatalogStoryComponent
                                            class="hidden md:block"
                                            :selected-item="selectedGridItem"
                                            :lesson-by-teachers-open-new-tab="tabItem.lessonByTeachersOpenNewTab"
                                            :lesson-by-teachers-image-height="tabItem.lessonByTeachersImageHeight"
                                        />
                                    </Container>
                                </div>
                                    <p class="h-[120px]"/>
                                    <Container class="px-6 md:px-0">
                                        <AboutRegionalHubsComponent v-bind="tabItem.regionalHubs"/>
                                    </Container>
                            </div>
                            <div v-if="tab=== 1" class="w-[48%] space-y-[15px]">
                                <p v-for="(item, index) in tabItem.items" :key="index">
                                    <b>{{ item.name }}</b>, {{ item.title }} 222
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Container from "../../../Layouts/Container";
import ReadOurStoryComponent from "./sections/ReadOurStoryComponent.vue";
import AboutOurWorkComponent from "./sections/AboutOurWorkComponent.vue";
import AboutAwardsComponent from "../about-awards/Component.vue";
import CorePlatformGridComponent from "./sections/CorePlatformGridComponent.vue";
import LessonCatalogStoryComponent from "./sections/LessonCatalogStoryComponent.vue";
import AboutRegionalHubsComponent from "../about-regional-hubs/Component.vue";
export default {
    computed: {},
    components: {
        LessonCatalogStoryComponent,
        AboutOurWorkComponent,
        ReadOurStoryComponent,
        Container,
        AboutAwardsComponent,
        CorePlatformGridComponent,
        AboutRegionalHubsComponent
    },
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        aboutAwards: { type: Object },
        corePlatform: { type: Object },
        regionalHubs: { type: Object },
        lessonByTeachersOpenNewTab:{
            type: Boolean,
            default: false
        },
        imageSrc:{
            type: String,
            default: 'https://widgets.guidestar.org/prod/v1/pdp/transparency-seal/10986729/svg'
        },
    },
    data() {
        return {
            tab: 0,
            selectedGridItem: null,
        };
    }
};
</script>
